import * as FiIcons from 'react-icons/fi';

const { FiActivity, FiBriefcase, FiStar, FiPieChart, FiSettings } = FiIcons;

export const TABS = [
  { id: 'trade',     label: 'Sniper',    icon: FiActivity },
  { id: 'positions', label: 'Positions', icon: FiBriefcase },
  { id: 'watchlist', label: 'Watchlist', icon: FiStar },
  { id: 'analytics', label: 'Analytics', icon: FiPieChart },
  { id: 'settings',  label: 'Settings',  icon: FiSettings },
];

export const DEFAULT_TAB = 'trade';
